
import React from "react";

export const LoadingComp = (props:any) => {
    return (<div className="loading_conatiner">
    <div className="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    {/*<p>Message Here...</p>*/}
  </div>)
}

export const NoDataComp = (props:any) => {

}